module.exports = __webpack_public_path__ + "static/media/Interview--illustration.27ac51d5.svg";